import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserBrands as fetchUserBrandsAPI } from "services/api/users";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { UserBrand } from "types/users";
import { getErrorMessage, isFresh } from "utils/helpers";
import { UserBrands } from "./reducer";
import apiConfig from "constants/apiConfig";

const STALE_TIME = apiConfig.FETCH_USER_BRANDS.staleTime;

export const fetchUserBrands = createAsyncThunk<UserBrand[], boolean, { rejectValue: string }>(
    'user/brands/fetch',
    async (force = false, { getState, rejectWithValue }) => {
        const state = getState() as { userBrands: UserBrands, auth: AuthState };
        if (!force &&
            isFresh(state.userBrands.last_fetched_at, STALE_TIME)
        ) {
            return rejectWithValue(ERROR.CACHED)
        }
        try {
            const brands = await fetchUserBrandsAPI(state.auth.selectedAgencyId!);
            return brands;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)